<template>
  <div class="profile-content profile-content-setings profile-content-orders">
    <div class="wrapper">
      <div class="desc main-desc">
        <b>{{ $t("MY OFFERS") }}</b>
      </div>
      <div v-if="offerHistory && offerHistory.length" class="profile-table">
        <div class="profile-table-wrapper profile-form-wrapper">
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <td>ID</td>
                  <td>{{ $t("Date/time") }}</td>
                  <td>{{ $t("Item") }}</td>
                  <td>{{ $t("Your Price") }}</td>
                  <td>{{ $t("Our Price") }}</td>
                  <td>{{ $t("Status") }}</td>
                  <td>{{ $t("Action") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in offerHistory" :key="i">
                  <td>{{ item.order_nr }}</td>
                  <td>{{ formatDate(item.date_time * 1000) }}</td>
                  <td>{{ item.title }}</td>
                  <td class="desc">
                    {{ item.currency }} {{ item.user_price }}
                  </td>
                  <td class="desc">
                    <b v-if="item.service_price">{{ item.currency }} {{ item.service_price }}</b>
                    <span v-else>-</span>
                  </td>
                  <td :class="getStatusClass(item.status)">
                    <span>{{ formatStatus(item.status) }}</span>
                  </td>
                  <td>
                    <button 
                      v-if="item.status == 'offer' || item.status == 'ready_for_payout'" 
                      class="button orange small" 
                      @click="openOfferModal(item)"
                    >
                      {{ $t("View Details") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="desc">
        {{ $t("No offers yet") }}
      </div>
    </div>

    <OfferModal 
      v-if="selectedOffer" 
      :offer="selectedOffer" 
      @close="selectedOffer = null" 
      @refresh="loadOffers"
    />
  </div>
</template>

<script>
import OfferModal from "./OfferModal.vue";

export default {
  name: "OffersHistory",
  components: {
    OfferModal,
  },
  data() {
    return {
      offerHistory: [],
      selectedOffer: null,
    };
  },
  mounted() {
    this.loadOffers();
  },
  methods: {
    loadOffers() {
      this.$http
        .get(process.env.VUE_APP_API + "offer/history")
        .then((res) => {
          if (res.data.status === "OK") {
            this.offerHistory = res.data.payload;
          }
        })
        .catch((err) => {
          if (err.response?.status === 401) {
            this.$parent.$parent.openSignInModal();
          }
        });
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    formatStatus(status) {
      return status
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },
    getStatusClass(status) {
      if (status === "approved") return "green";
      if (status === "declined_by_user" || status === "declined_by_service") return "red";
      return "";
    },
    openOfferModal(offer) {
      this.selectedOffer = offer;
    },
  },
};
</script>

<style scoped>
.button.small {
  padding: 8px 16px;
  font-size: 13px;
}
</style>
